/*
 *  jquery.tps-validate.js - v1.0.0
 *  Client-side (jQuery Plugin) form validation.
 *
 *  Made by The Pixel Shop
 *  Under MIT License
 *
 *  jQuery plugin development boilerplate: https://github.com/jquery-boilerplate/jquery-boilerplate
 *  REQUIRES jQuery Validation Plugin - v1.17.0 - https://jqueryvalidation.org/
 */

;(function($, window, document, undefined) {

	'use strict';

	// jQuery function/method to trigger in a jQuery object
	// Example: $('form').tpsValidate();
	var pluginName = 'tpsValidate';

	// All default options that can be replaced
	// Example: $('form').tpsValidate({ requiredFieldMessage: 'This field is super-required' });
	var defaults = {
		elementValidated: null,
		isSteppedForm: false,

		// Field added to all fields validated
		fieldToValidateClass: 'tps-to-validate',

		// Since Kentico has a unique form wrapping all page, this is the dom selector used to restricted the validation
		formContainerSelector: 'div.form-container',

		// Stepped form
		formSteppedContainerClass: 'form-stepped',
		activeStepSelector: '.tps-form-step.active',
		nextStepSelector: '.button-next-step',

		// Email validation
		emailFieldSelector: null,
		emailFieldMessage: 'A valid email address is required',

		// Phone (US, CA) validation
		phoneFieldSelector: null,
		phoneFieldMessage: 'A valid phone number is required',

		// Date (YYYY-MM-DD) validation
		dateFieldSelector: null,
		dateFieldMessage: 'A valid date is required',

		// Zipcode (CA) validation
		zipcodeFieldSelector: null,
		zipcodeFieldMessage: 'A valid zipcode is required',

		// Required validation
		requiredFieldSelector: null,
		requiredFieldMessage: 'This field is required',

		// Required custom validation (messages)
		requiredFieldsCustomMessages: []
	};

	function Plugin(element, options) {
		this._defaults = defaults;
		this._name = pluginName;
		this.element = element;
		this.settings = $.extend({}, defaults, options);
		this.init();
	}

	$.extend(Plugin.prototype, {
		// Plugin init (instance)
		init: function() {
			// Test if 'jQuery Validation Plugin' exists and it's defined
			if (! $.fn.validate) {
				console.log('jQuery.fn.validate not defined');
				return false;
			}

			if ($(this.element).find(this.settings.formContainerSelector).hasClass(this.settings.formSteppedContainerClass)) {
				this.settings.isSteppedForm = true;
			}

			// Internal methods
			this.addCustomValidators();
			this.addBasicValidation();
			this.addMultiFormValidation();
			this.addSteppedFormValidation();
			this.addEmailValidation();
			this.addPhoneValidation();
			// this.addDateValidation(); // @TODO - we need to be able to trigger the Kentico datepicker select event, if not the UX is compromised
			this.addZipcodeValidation();
			this.addRequiredValidation();
		},

		// Plugin destroy (instance)
		// Example: $('form').destroy();
		destroy: function() {
			$(this.element).removeData('plugin_' + pluginName);
		},

		// Add custom validators to $.fn.validate
		addCustomValidators: function() {
			// Date inverted (YYYY-MM-DD)
			$.validator.addMethod('dateInverted', function(value, element) {
				return this.optional(element) || /^\d{4}-\d{1,2}-\d{1,2}$/.test(value);
			}, 'The specified date is invalid');

			// Zipcode (A1A 1A1)
			$.validator.addMethod('zipcodeCA', function(value, element) {
				return this.optional(element) || /^([ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]) (\d[ABCEGHJKLMNPRSTVWXYZ]\d)$/i.test(value);
			}, 'The specified CA zipcode is invalid');
		},

		// Add basic/base validation to the Kentico form
		addBasicValidation: function() {
			this.elementValidated = $(this.element).validate({
				errorClass: 'EditingFormErrorLabel',
				errorElement: 'span',
				onsubmit: false,

				onclick: function(element) {
					// Checkboxes
					if ($(element).is('input[type="checkbox"]')) {
						var self = this;

						$(element).siblings('input[type="checkbox"]').addBack().each(function() {
							self.element(this);
						});

					// All other elements (DEFAULT JQUERY PLUGIN CODE)
					} else {
						// Click on selects, radiobuttons and checkboxes
						if (element.name in this.submitted) {
							this.element(element);

						// Or option elements, check parent select in that case
						} else if (element.parentNode.name in this.submitted) {
							this.element(element.parentNode);
						}
					}
				},

				onfocusout: function(element) {
					if (! this.checkable(element)) {
						this.element(element);
					}
				},

				errorPlacement: function (error, element) {
					var target = element.closest('.EditingFormControlNestedControl');

					if (0 == target.find('span.EditingFormErrorLabel').length) {
						error.appendTo(target);
					}
				},

				highlight: function(element, errorClass, validClass) {
                    $(element).parent().addClass('Error');
                    $('[for="' + $(element).attr('id') + '"').addClass('Error');
				},

				unhighlight: function(element, errorClass, validClass) {
                    $(element).parent().removeClass('Error');
                    $('[for="' + $(element).attr('id') + '"').removeClass('Error');
				}
			});
		},

		// Add multi-form validation
		// In addition to the setting onsubmit: false
		addMultiFormValidation: function() {
			var self = this;

			$(this.element).on('click', 'input[type="submit"]', function(e) {
				var valid = true;

				$(this).closest(self.settings.formContainerSelector).find('.' + self.settings.fieldToValidateClass).filter(':visible').each(function() {
					if (!self.elementValidated.element(this)) {
						valid = false;
					}
				});

				if (!valid) {
					return false;
				}

				return true;
			});
		},

		// Add stepped form validation
		addSteppedFormValidation: function() {
			var self = this;

			if (this.settings.isSteppedForm) {
				$(this.element).find(this.settings.formContainerSelector).on('click', this.settings.nextStepSelector, function(e) {
					var valid = true;

					$(this).closest(self.settings.formContainerSelector).find(self.settings.activeStepSelector).find('.' + self.settings.fieldToValidateClass).filter(':visible').each(function() {
						if (!self.elementValidated.element(this)) {
							valid = false;
						}
					});

					if (!valid) {
						e.stopPropagation();
					}
				});
			}
		},

		// Add email validation
		addEmailValidation: function() {
			var self = this;

			if (this.settings.emailFieldSelector) {
				$(this.element).find(this.settings.formContainerSelector).find(this.settings.emailFieldSelector).filter(':visible').each(function() {
					var element = $(this);

					element.addClass(self.settings.fieldToValidateClass);

					element.rules('add', {
						email: true,

						messages: {
							email: self.settings.emailFieldMessage
						}
					});
				});
			}
		},

		// Add phone number validation
		addPhoneValidation: function() {
			var self = this;

			if (this.settings.phoneFieldSelector) {
				$(this.element).find(this.settings.formContainerSelector).find(this.settings.phoneFieldSelector).filter(':visible').each(function() {
					var element = $(this);

					element.addClass(self.settings.fieldToValidateClass);

					element.rules('add', {
						phoneUS: true,

						messages: {
							phoneUS: self.settings.phoneFieldMessage
						}
					});
				});
			}
		},

		// Add date validation
		addDateValidation: function() {
			var self = this;

			if (this.settings.dateFieldSelector) {
				$(this.element).find(this.settings.formContainerSelector).find(this.settings.dateFieldSelector).filter(':visible').each(function() {
					var element = $(this);

					element.addClass(self.settings.fieldToValidateClass);

					element.rules('add', {
						dateInverted: true,

						messages: {
							dateInverted: self.settings.dateFieldMessage
						}
					});
				});
			}
		},

		// Add zipcode validation
		addZipcodeValidation: function() {
			var self = this;

			if (this.settings.zipcodeFieldSelector) {
				$(this.element).find(this.settings.formContainerSelector).find(this.settings.zipcodeFieldSelector).filter(':visible').each(function() {
					var element = $(this);

					element.addClass(self.settings.fieldToValidateClass);

					element.rules('add', {
						zipcodeCA: true,

						messages: {
							zipcodeCA: self.settings.zipcodeFieldMessage
						}
					});
				});
			}
		},

		// Add required validation
		addRequiredValidation: function() {
			var self = this;

			if (this.settings.requiredFieldSelector) {
				// Default message (for all fields)
				$(this.element).find(this.settings.formContainerSelector).find(this.settings.requiredFieldSelector).filter(':visible').each(function() {
					var element = $(this);

					if(!$(this).parent().hasClass('tps-not-required')){
						element.addClass(self.settings.fieldToValidateClass);
					}

					// Checkboxes
					if (element.is('input[type="checkbox"]')) {
						element.rules('add', {
							required: function (element) {
								var checkboxes = $(element).siblings('input[type="checkbox"]').addBack();

								if (0 == checkboxes.filter(':checked').length) {
									return true;
								}

								return false;
							},

							messages: {
								required: self.settings.requiredFieldMessage
							}
						});

					// All other elements
					} else {
						element.rules('add', {
							required: true,

							messages: {
								required: self.settings.requiredFieldMessage
							}
						});
					}
				});

				if (this.settings.requiredFieldsCustomMessages.length) {
					// Custom messages (per field)
					$.each(this.settings.requiredFieldsCustomMessages, function(key, value) {
						$(self.settings.formContainerSelector).find(value.selector).filter(':visible').each(function() {
							var element = $(this);

							element.rules('remove', 'required');

							// Checkboxes
							if (element.is('input[type="checkbox"]')) {
								element.rules('add', {
									required: function (element) {
										var checkboxes = $(element).siblings('input[type="checkbox"]').addBack();

										if (0 == checkboxes.filter(':checked').length) {
											return true;
										}

										return false;
									},

									messages: {
										required: value.message
									}
								});

							// All other elements
							} else {
								element.rules('add', {
									required: true,

									messages: {
										required: value.message
									}
								});
							}
						});
					});
				}
			}
		}
	});

	$.fn[pluginName] = function(options) {
		return this.each(function() {
			if (! $.data(this, 'plugin_'+ pluginName)) {
				$.data(this, 'plugin_'+ pluginName, new Plugin(this, options));
			}
		});
	};

})(jQuery, window, document);
